module.exports = __webpack_public_path__ + "img/DE00351.ea54b2f5.png";